import React from 'react';
import { Button, Form, Input, message, Modal } from 'antd';
import { AuditOutlined } from '@ant-design/icons';
import Request from 'common/network/Request';
import potentialCandidateApis from 'modules/dashboard/api/potential-candidate';
import { Controller, useForm } from 'react-hook-form';
import { LuPencilLine } from 'react-icons/lu';

const ConfirmLearn = ({ record, onSuccess, formUpdate }) => {
  const inputRef = React.useRef();
  const [showConfirmModal, setShowConfirmModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      confirm_sale_citizen_id: record?.confirm_sale_citizen_id || '',
    },
  });

  if (!!record?.confirm_sale_citizen_id && !formUpdate) {
    return null;
  }

  const handleSubmitForm = async (values) => {
    setLoading(true);
    try {
      const response = await Request.post(
        potentialCandidateApis.change_confirm_sale_citizen_id,
        {
          id: record?.id,
          confirm_sale_citizen_id: values.confirm_sale_citizen_id,
        },
      );
      message[response.success ? 'success' : 'error'](response.message);
      if (response.success) {
        setShowConfirmModal(false);
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      }
    } catch (error) {}
    setLoading(false);
  };

  return (
    <>
      {!formUpdate ? (
        <Button
          icon={<AuditOutlined />}
          className="bg-emerald-500 text-white hover:!text-emerald-500 hover:!border-emerald-500"
          block
          onClick={() => setShowConfirmModal(true)}
          disabled={showConfirmModal}
        >
          Chốt học BVLN
        </Button>
      ) : (
        <LuPencilLine
          className="text-primary cursor-pointer"
          onClick={() => setShowConfirmModal(true)}
          disabled={showConfirmModal}
        />
      )}
      <Modal
        title="Xác nhận chốt học BVLN"
        footer={null}
        open={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        destroyOnClose
        afterOpenChange={(open) => open && inputRef.current?.focus()}
      >
        <Form
          colon={false}
          onFinish={handleSubmit(handleSubmitForm)}
          layout="vertical"
          preserve={false}
        >
          <Form.Item
            label="Số CCCD/CMND"
            required
            validateStatus={
              errors?.confirm_sale_citizen_id ? 'error' : undefined
            }
            help={errors?.confirm_sale_citizen_id?.message}
          >
            <Controller
              render={({ field }) => (
                <Input {...field} placeholder="010123456789" ref={inputRef} />
              )}
              name="confirm_sale_citizen_id"
              control={control}
              rules={{
                required: 'Vui lòng nhập số CCCD/CMND',
              }}
            />
          </Form.Item>
          <div className="mt-2 text-end">
            <Button type="primary" htmlType="submit" loading={loading}>
              Xác nhận
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ConfirmLearn;
